import { render, staticRenderFns } from "./InfluencersPage.vue?vue&type=template&id=bd816712&scoped=true&"
import script from "./InfluencersPage.vue?vue&type=script&lang=js&"
export * from "./InfluencersPage.vue?vue&type=script&lang=js&"
import style0 from "./InfluencersPage.vue?vue&type=style&index=0&id=bd816712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd816712",
  null
  
)

export default component.exports